import { Sidebar, VideosContainer } from "../components"
import "../../App.css"
export const VideoListing = () => {
    return (
        <div className="main-container">
            <Sidebar />
            <VideosContainer />
        </div>

    )
}
